import { render, staticRenderFns } from "./UserErrorModal.vue?vue&type=template&id=4a404dbd&scoped=true&"
import script from "./UserErrorModal.vue?vue&type=script&lang=ts&"
export * from "./UserErrorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a404dbd",
  null
  
)

export default component.exports